import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Save, Bell, BellRing, X } from "lucide-react";

export function PipelineFilters({ q, setQ, onSave, canSave, saved, onApplySaved, onDelSaved, tags, tagFilter, toggleTag, clearTags, sort, setSort }) {
  return (
    <div className="space-y-4" data-testid="pipeline-filters">
      <div className="space-y-1.5">
        <label htmlFor="pipeline-search" className="text-xs font-medium text-muted-foreground">Search candidates</label>
        <div className="flex gap-2">
          <div className="relative flex-1 min-w-0">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input id="pipeline-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Skill, tool or name…" data-testid="pipeline-cv-search" className="pl-9 h-9" />
          </div>
          <Button variant="outline" size="sm" onClick={onSave} disabled={!canSave} data-testid="save-search-btn" className="gap-1.5 h-9"><Save className="h-4 w-4" /> Save</Button>
        </div>
      </div>
      {saved.length > 0 && (
        <div className="space-y-1.5" data-testid="saved-searches">
          <div className="text-xs text-muted-foreground flex items-center gap-1.5"><Bell className="h-3.5 w-3.5" /> Saved searches</div>
          <div className="flex flex-wrap gap-1.5">
            {saved.map((s) => (
              <span key={s.id} data-testid={`saved-search-${s.id}`} className="inline-flex items-center gap-1.5 rounded-full border border-border pl-3 pr-1.5 py-1 text-xs">
                <button onClick={() => onApplySaved(s)} data-testid={`apply-saved-${s.id}`} className="inline-flex items-center gap-1.5 hover:text-primary">
                  {s.new_matches > 0 && <BellRing className="h-3 w-3 text-primary" />}<span className="font-medium">{s.term}</span>
                  {s.new_matches > 0 && <span className="px-1.5 rounded-full bg-primary/15 text-primary text-[10px] font-semibold" data-testid={`saved-badge-${s.id}`}>{s.new_matches} new</span>}
                </button>
                <button onClick={() => onDelSaved(s.id)} data-testid={`del-saved-${s.id}`} aria-label={`Delete saved search ${s.term}`} className="text-muted-foreground hover:text-rose-400"><X className="h-3 w-3" /></button>
              </span>
            ))}
          </div>
        </div>
      )}
      {tags.length > 0 && (
        <div className="space-y-1.5" data-testid="tag-filter-bar">
          <div className="text-xs text-muted-foreground flex items-center justify-between">Tags{tagFilter.size > 0 && <button onClick={clearTags} data-testid="tag-filter-clear" className="hover:text-foreground">Clear</button>}</div>
          <div className="flex flex-wrap gap-1.5 max-h-40 overflow-y-auto">
            {tags.map((t) => <button key={t} onClick={() => toggleTag(t)} data-testid={`tag-filter-${t}`} className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${tagFilter.has(t) ? "bg-primary/15 border-primary/50 text-primary" : "border-border text-muted-foreground hover:text-foreground"}`}>{t}</button>)}
          </div>
        </div>
      )}
      <label className="flex items-center justify-between gap-2 text-xs text-muted-foreground">Order within stages
        <select value={sort} onChange={(e) => setSort(e.target.value)} data-testid="stage-aging-sort" className="rounded-md border border-border bg-background px-2.5 py-1.5 text-sm text-foreground">
          <option value="score">Highest fit</option><option value="waiting">Longest waiting</option>
        </select>
      </label>
    </div>
  );
}
